import React from 'react'
import {WuToggle} from '@npm-questionpro/wick-ui-lib'
import styles from './CustomSwitch.module.scss'

interface ICustomSwitchProps {
  isChecked: boolean
  handleChange: (checked: boolean) => void
  disabled?: boolean
  label: string
}

export const CustomSwitch: React.FC<ICustomSwitchProps> = ({
  isChecked,
  handleChange,
  disabled,
  label,
}) => {
  return (
    <div className={styles.customSwitch}>
      <WuToggle
        id={label}
        Label={label}
        labelPosition="right"
        disabled={disabled}
        checked={isChecked}
        onChange={handleChange}
      />
    </div>
  )
}
